export default __webpack_public_path__ + "static/media/careteam_patient_records_clock.d00d069c.svg";